module.exports = __webpack_public_path__ + "assets/img/de-e99d89ae.png";